import BaseRootOption from "%/dynamic-component-editor/classes/base-root-option";
import { inspectorTools } from "%/dynamic-component-editor/inspector/inspector-tool-map";

// Editor-only and inert at runtime: the published page never reads this key
// (pinned by tests/unit/builder/elements/event-preview-state-never-reaches-the-live-page.test.mjs).
export const EVENT_PREVIEW_STATE_AUTOMATIC = "Automatic";
export const EVENT_PREVIEW_STATE_PRE_EVENT = "Pre-event";
export const EVENT_PREVIEW_STATE_ROOM_OPEN = "Waiting to start";
export const EVENT_PREVIEW_STATE_LIVE = "Live";
export const EVENT_PREVIEW_STATE_DEGRADED = "Degraded";
export const EVENT_PREVIEW_STATE_ERROR = "Error";
export const EVENT_PREVIEW_STATE_ENDED = "Ended";

export const EVENT_PREVIEW_STATES = [
  EVENT_PREVIEW_STATE_AUTOMATIC,
  EVENT_PREVIEW_STATE_PRE_EVENT,
  EVENT_PREVIEW_STATE_ROOM_OPEN,
  EVENT_PREVIEW_STATE_LIVE,
  EVENT_PREVIEW_STATE_DEGRADED,
  EVENT_PREVIEW_STATE_ERROR,
  EVENT_PREVIEW_STATE_ENDED,
];

export default class EventPreviewState extends BaseRootOption {
  static label = "Preview State";

  static descriptionMessage = "Preview how this event's surfaces look in each state. "
    + "This only affects the editor — the live page always shows the event's real state.";

  static userInterfaceComponent = {
    component: inspectorTools.RADIO_BAR,
    props: {
      options: EVENT_PREVIEW_STATES.map(state => ({ label: state, value: state })),
    },
  };

  static defaultValue = EVENT_PREVIEW_STATE_AUTOMATIC;
}
